import { UserRoleDto } from '@/api/generated';
import { UsersListTranslation } from '@/assets/locales/views/usersList/usersList.translation.en.ts';

export const usersListTranslation: UsersListTranslation = {
  content: {
    dialog: {
      archiveAcceptedDevelopmentPaths: {
        button: {
          perform: 'Wykonaj',
        },
        endingText: 'Czy na pewno chcesz ją wykonać?',
        leadingText: 'Wykonanie tej akcji spowoduje:',
        pointsList: {
          first:
            "przesunięcie wszystkich zaakceptowanych Planów Rozwojowych do statusu 'Zarchiwizowane'.",
        },
      },
      getSsoUsersStats: {
        button: {
          download: 'Pobierz szczegóły o użytkownikach',
        },
      },
      resetPassword: {
        button: {
          cancel: 'Anuluj',
          close: 'Zamknij',
          copied: 'Skopiowano',
          copy: 'Kopiuj',
          reset: 'Resetuj hasło',
        },
        description: 'Wybierz, jak ustawić nowe hasło dla: {{name}}.',
        error: {
          conflict: 'Nie można zresetować hasła tego konta.',
          copyFailed: 'Nie udało się skopiować hasła. Zaznacz je i skopiuj ręcznie.',
          generic: 'Nie udało się zresetować hasła. Spróbuj ponownie.',
          rejected: 'Hasło nie spełnia wymagań. Wpisz inne albo wygeneruj je automatycznie.',
        },
        form: {
          generated: 'Wygeneruj hasło automatycznie',
          hidePassword: 'Ukryj hasło',
          noEmail: 'Użytkownik nie dostanie wiadomości e-mail. Przekaż mu hasło samodzielnie.',
          passwordHint: 'Od 8 do 128 znaków.',
          passwordLabel: 'Nowe hasło',
          showPassword: 'Pokaż hasło',
          temporary: 'Hasło tymczasowe',
          typed: 'Wpisz własne hasło',
        },
        result: {
          description: 'Hasło zostało zmienione. Przekaż je użytkownikowi.',
          warning:
            'Hasło nie jest nigdzie zapisywane. Po zamknięciu okna nie będzie można go wyświetlić ponownie.',
        },
        temporaryHint: 'Przy pierwszym logowaniu użytkownik ustawi własne hasło.',
        title: 'Reset hasła',
      },
      sendEmailToVerifySso: {
        button: {
          confirm: 'Wyślij',
          send: 'Wyślij e-mail do weryfikacji konta',
        },
        content: {
          text: 'Ta akcja wyśle e-mail z prośbą o weryfikację konta w aplikacji do wszystkich nieaktywnych użytkowników. Czy na pewno chcesz kontynuować?',
        },
      },
    },
    table: {
      actions: 'Akcje',
      email: 'Email',
      enabled: 'Aktywne',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      resetPasswordButton: 'Reset hasła',
      role: {
        [UserRoleDto.Admin]: 'Administrator',
        [UserRoleDto.AdminCertification]: 'Administrator certyfikacji',
        [UserRoleDto.AdminDevelopment]: 'Administrator rozwoju',
        [UserRoleDto.AdminSuccession]: 'Administrator sukcesji',
        [UserRoleDto.Employee]: 'Pracownik',
        [UserRoleDto.Hrbp]: 'HRBP',
        [UserRoleDto.HrbpHq]: 'HRBP HQ',
        [UserRoleDto.ManagerP1]: 'Przełożony',
        [UserRoleDto.ManagerP2]: 'Przełożony P2',
      },
      roles: 'Role',
      rolesEmpty: 'Brak ról',
      sap: 'SAP',
      ssoCreated: 'SSO utworzone',
      verifiedInSso: 'Zweryfikowany w SSO',
    },
  },
  form: {
    button: {
      archiveAcceptedDevelopmentPaths: 'Archiwizacja planów rozwojowych',
      menu: {
        downloadTemplateFile: 'Pobierz plik wzorcowy',
      },
      uploadUsers: 'Wgraj użytkowników',
    },
    disabled: 'Nieaktywne',
    enabled: 'Aktywne',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    role: 'Rola',
    ssoCreated: 'SSO utworzone',
    ssoCreatedFalse: 'Nieutworzone',
    ssoCreatedTrue: 'Utworzone',
    verifiedInSso: 'Zweryfikowany w SSO',
    verifiedInSsoFalse: 'Niezweryfikowany',
    verifiedInSsoTrue: 'Zweryfikowany',
  },
};
